import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function OptionsList() {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    fetchOptions()
  }, [search])

  const fetchOptions = () => {
    setLoading(true)
    let url = '/api/options'
    if (search) url += `?search=${encodeURIComponent(search)}`

    fetch(url)
      .then(response => response.json())
      .then(data => {
        setOptions(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching options:', err)
        setLoading(false)
      })
  }

  const deleteOption = (id) => {
    if (!confirm('Are you sure you want to delete this option?')) return

    fetch(`/api/options/${id}`, { method: 'DELETE' })
      .then(response => {
        if (response.ok) {
          setOptions(options.filter(o => o.id !== id))
        } else {
          return response.json().then(data => {
            alert(data.errors?.join(', ') || 'Failed to delete option')
          })
        }
      })
      .catch(err => console.error('Error deleting option:', err))
  }

  return (
    <div className="px-4 sm:px-0">
      <div className="sm:flex sm:items-center sm:justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Options</h1>
          <p className="mt-2 text-sm text-gray-600">
            Add-on packages that modify configurations (can add or remove parts)
          </p>
        </div>
        <div className="mt-4 sm:mt-0">
          <Link
            to="/options/new"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-900 hover:bg-gray-800"
          >
            + Add Option
          </Link>
        </div>
      </div>

      {/* Search */}
      <div className="bg-white shadow rounded-lg p-4 mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Search
        </label>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name..."
          className="w-full md:w-1/2 border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
        />
      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="text-gray-500">Loading options...</div>
          </div>
        ) : options.length === 0 ? (
          <div className="flex justify-center items-center h-64">
            <div className="text-gray-500">No options found</div>
          </div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Parts Count
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {options.map((option) => (
                <tr key={option.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {option.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {option.parts_count} part modification{option.parts_count !== 1 ? 's' : ''}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                    <Link
                      to={`/options/${option.id}/edit`}
                      className="text-gray-600 hover:text-gray-900"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => deleteOption(option.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="mt-4 text-sm text-gray-600">
        Showing {options.length} option{options.length !== 1 ? 's' : ''}
      </div>
    </div>
  )
}
